import ShButton from '@/components/Helpers/ShButton';
import ShModalWindow from '@/components/Helpers/ShModalWindow';

export default {
  name: 'ConfigurationModalStepFive',

  components: {
    ShButton,
    ShModalWindow,
  },
};
